module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Bold.807ce222e7ba3834b714ae5dcd7abd92.woff";